import { render, staticRenderFns } from "./ShoppingBagIcon.vue?vue&type=template&id=6b95e6ac&scoped=true&"
import script from "./ShoppingBagIcon.vue?vue&type=script&lang=js&"
export * from "./ShoppingBagIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingBagIcon.vue?vue&type=style&index=0&id=6b95e6ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95e6ac",
  null
  
)

export default component.exports